import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'attention-modal.ts',
    templateUrl: './attention-modal.component.html',
    styleUrls: ['./attention-modal.component.scss']
})
export class AttentionModalComponent {
    public constructor(
        public dialogRef: MatDialogRef<AttentionModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    getDescription() {
        return this.data.description;
    }

    performAction() {
        this.dialogRef.close(true);
    }
}
